import { Page } from '@/core/architecture'

import { StoreCollectionDetailsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * StoreCollectionDetails Page
 * Implemented as a practical sample.
 */
export const StoreCollectionDetails: Page = () => {
  const { state, actions } = useViewModel()

  return <StoreCollectionDetailsTemplate state={state} {...actions} />
}
